import { Container } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MaintainanceState from "../../components/global/MantainanceState";
import { RootState } from "../../store";
import { routes } from "../routes";

function Mantainance() {
  const maintenanceMode = useSelector(
    (state: RootState) => state.user.maintenance,
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (maintenanceMode) return;

    const next = sessionStorage.getItem("maintenance_return_to");
    sessionStorage.removeItem("maintenance_return_to");

    const target =
      next && !next.startsWith(routes.OTHER_ROUTES.MANTAINANCE) ? next : "/";
    navigate(target, { replace: true });
  }, [maintenanceMode]);

  return (
    <div
      className="app-bg"
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container maxWidth="sm">
        <MaintainanceState />
      </Container>
    </div>
  );
}

export default Mantainance;